import {
  Button,
  Chip,
  Dialog,
  DialogTitle,
  Grid,
  Paper,
  Typography
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import React, { FunctionComponent, useEffect, useState } from "react";
import { Link, RouteProps } from "react-router-dom";
import {
  getSingleTicket,
  getTicketContents
} from "../../api/ticket/get";
import {
  closeTicket,
  makeSeenTicket
} from "../../api/ticket/put";
import TicketCards from "../../components/CardList/ticketCards";
import RonadIcons from "../../components/iconComponent";
import handleError from "../../utils/handleError";
import handleNotfication from "../../utils/handleNotfication";
import { translate } from "../../utils/helpers";
import AddMessage from "./components/addMessage";
import CategoryServiceForm from "./components/categoryServiceForm";
import TransferTicket from "./components/transferTicket";

const useStyles = makeStyles((theme) =>
  createStyles({
    chatHeader: {
      padding: "16px",
      borderBottomLeftRadius: "0",
      borderBottomRightRadius: "0",
    },
    chatBody: {
      padding: "16px",
      borderRadius: "0",
    },
    chatFooter: {
      border: "1px solid #ededed",
      borderTopLeftRadius: "0",
      borderTopRightRadius: "0",
      padding: "16px",
    },
  })
);

const ticketPriority = {
  LOW: {
    id: 0,
    name: "LOW",
    title: "کم",
    color: "#007644",
    bcolor: "#e8faea",
  },
  NORMAL: {
    id: 1,
    name: "NORMAL",
    title: "متوسط",
    color: "#FF7E07",
    bcolor: "#ffeedf",
  },
  HIGH: {
    id: 2,
    name: "HIGH",
    title: "زیاد",
    color: "#FF0000",
    bcolor: "#fffafa",
  },
  CRITICAL: {
    id: 3,
    name: "CRITICAL",
    title: "اضطراری",
    color: "maroon",
    bcolor: "#fffafa",
  },
};

const TicketDetails = (props: FunctionComponent<RouteProps>) => {
  const ticketId = props.match.params.id;
  const [ticketObject, setTicketObject] = useState(
    undefined
  );
  const [contents, setContents] = useState<any[] | undefined>(undefined);

  const [modal, setModal] = useState("");

  const classes = useStyles();

  useEffect(() => {
    getTicketById();
    getContents();
  }, []);

  const getTicketById = async () => {
    try {
      const ticket = await getSingleTicket(ticketId);
      setTicketObject(ticket.data);
      if (ticket.data.seen == 0) {
        await makeSeen(ticket.data);
      }
    } catch (error) {
      handleError(error);
    }
  };
  const getContents = async () => {
    try {
      const content = await getTicketContents(ticketId);
      setContents(content.data);
    } catch (error) {
      handleError(error);
    }
  };
  const handleClose = async () => {
    try {
      await closeTicket(ticketObject.id);
      handleNotfication("تیکت با موفقیت بسته شد.", "success");
      reloadPage();
    } catch (error) {
      handleError(error);
    }
  };

  const reloadPage = () => {
    getTicketById();
    getContents();
  };

  const makeSeen = async (ticket) => {
    if (
      ticket.assignmentType === "FFC" &&
      ticket.status === "ASSIGNEE_ANSWERED"
    ) {
      return;
    } else if (
      ticket.assignmentType === "PARTNER" &&
      ["OWNER_ANSWERED", "OPEN"].includes(ticket.status)
    ) {
      return;
    } else {
      await makeSeenTicket(ticketId);
    }
  };
  return (
    <React.Fragment>
      <Typography variant="h6" component="h2" style={{ marginBottom: "24px" }}>
        تیکت شماره {ticketObject?.tracking}
      </Typography>
      {ticketObject && <CategoryServiceForm ticket={ticketObject} />}
      <Paper className={classes.chatHeader}>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          spacing={1}
          alignItems="center"
          style={{ padding: "8px" }}
        >
          {ticketObject?.linkType && (
            <Grid item style={{ marginLeft: "auto" }}>
              <span>
                شماره {ticketObject.linkType === "order" ? "سفارش" : "محموله"}:
              </span>
              <Link
                to={
                  ticketObject.linkType === "order"
                    ? `/orders/${ticketObject.linkId}`
                    : `/parcels/details/${ticketObject.linkId}`
                }
              >
                {ticketObject.linkId}
              </Link>
            </Grid>
          )}
          <Grid item>
            <Typography variant="subtitle2">اولویت:</Typography>
          </Grid>
          <Grid item md={1} lg={1}>
            {/*INSERT PRIORITY DATA*/}
            {ticketObject && (
              <Chip
                icon={
                  <RonadIcons
                    name="circle"
                    size="14px"
                    fill={ticketPriority[ticketObject?.priority].color}
                    color="none"
                  />
                }
                label={ticketPriority[ticketObject?.priority].title}
                style={{
                  color: ticketPriority[ticketObject?.priority].color,
                  backgroundColor:
                    ticketPriority[ticketObject?.priority].bcolor,
                  fontSize: "16px",
                }}
              />
            )}
          </Grid>
          <Grid item md={1} lg={3}>
            <Typography variant="subtitle2">
              وضعیت:
              {translate(
                `${ticketObject?.assignee?.type}_${ticketObject?.status}`,
                "ticket"
              )}
            </Typography>

            {/*insert status data */}
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              size="medium"
              component="span"
              color="primary"
              onClick={() => setModal("TRANSFER")}
            >
              انتقال
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              size="medium"
              component="span"
              color="default"
              onClick={handleClose}
              disabled={ticketObject?.status == "CLOSED"}
            >
              بستن تیکت
            </Button>
          </Grid>
        </Grid>
      </Paper>
      <Paper className={classes.chatBody}>
        {contents?.map((el) => {
          return (
            <TicketCards
              data={el}
              ticketId={ticketId}
              reloadMessage={getContents}
            />
          );
        })}
      </Paper>
      <Paper className={classes.chatFooter}>
        <AddMessage reloadPage={getContents} id={ticketId} />
      </Paper>
      <Dialog
        open={modal === "TRANSFER"}
        onClose={() => setModal("")}
        aria-labelledby="responsive-dialog-title"
        maxWidth="sm"
        fullWidth
        style={{ padding: "16px" }}
      >
        <DialogTitle>
          <Grid container justifyContent="center" justify="center">
            <p style={{ marginTop: "-8px" }}>انتقال تیکت</p>
          </Grid>
        </DialogTitle>

        <Grid container direction="column">
          <TransferTicket
            reloadPage={reloadPage}
            handleCloseModal={() => setModal("")}
            ticketId={ticketId}
          />
        </Grid>
      </Dialog>
    </React.Fragment>
  );
};

export default TicketDetails;
